/* Version: 3.5.155 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { TOOLTIP_ACTIONS } from './constants.js';

var CLICK_TOGGLE = TOOLTIP_ACTIONS.CLICK_TOGGLE,
  CLICK_CLOSE = TOOLTIP_ACTIONS.CLICK_CLOSE,
  CLICK_OUTSIDE = TOOLTIP_ACTIONS.CLICK_OUTSIDE,
  PRESS_ESCAPE = TOOLTIP_ACTIONS.PRESS_ESCAPE;
function clickReducer(state, _ref) {
  var type = _ref.type;
  switch (type) {
    // toggle works as you'd expect
    case CLICK_TOGGLE:
      return _objectSpread(_objectSpread({}, state), {}, {
        showTooltip: !state.showTooltip
      });
    // clicks and escape work as expected...
    case CLICK_CLOSE:
    case CLICK_OUTSIDE:
    case PRESS_ESCAPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        showTooltip: false
      });
    // ... except clicking the tooltip body, which does nothing (need to click the close button)
    // istanbul ignore next
    default:
      return state;
  }
}

export { clickReducer as default };
